import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Home, Sparkles, Package, Calendar, Clock, HardHat, Baby, KeyRound } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Building2,
      title: 'Commercial Cleaning',
      description: 'Professional office and workspace cleaning tailored to your business needs',
      image: 'https://images.pexels.com/photos/245219/pexels-photo-245219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      gridClass: 'col-span-full md:col-span-8 row-span-2'
    },
    {
      icon: Home,
      title: 'Residential',
      description: 'Make your home sparkle with our thorough residential cleaning',
      image: 'https://images.unsplash.com/photo-1774716925788-5c4fc543d688?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMGtpdGNoZW4lMjBjb3VudGVyfGVufDB8fHx8MTc3NjY0OTI3Mnww&ixlib=rb-4.1.0&q=85',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: Sparkles,
      title: 'Deep Cleaning',
      description: 'Intensive cleaning for every nook and cranny',
      image: 'https://images.pexels.com/photos/36962178/pexels-photo-36962178.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: Package,
      title: 'Move-in/out',
      description: 'Complete cleaning for transitions',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: Calendar,
      title: 'Weekly & Bi-Weekly',
      description: 'Regular maintenance cleaning',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: Clock,
      title: 'Monthly Service',
      description: 'Flexible monthly cleaning plans',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: HardHat,
      title: 'Post-Construction',
      description: 'Specialized debris & dust cleaning after renovations (custom quote)',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: Baby,
      title: 'Perinatal Support',
      description: 'For expecting and existing parents',
      gridClass: 'col-span-4 row-span-1'
    },
    {
      icon: KeyRound,
      title: 'Airbnbs',
      description: 'Quick turnover for short- and long-term rentals',
      gridClass: 'col-span-4 row-span-1'
    }
  ];

  return (
    <section id="services" className="py-32" style={{ background: '#F3F4F6' }}>
      <div className="container mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span
            className="text-xs font-bold tracking-[0.2em] uppercase mb-4 inline-block"
            style={{ color: '#0284C7' }}
          >
            OUR SERVICES
          </span>
          <h2
            className="text-3xl sm:text-4xl tracking-tight font-medium"
            style={{ fontFamily: 'Outfit', color: '#0F172A' }}
          >
            Specialized Cleaning Solutions
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`${service.gridClass} rounded-2xl overflow-hidden hover-lift cursor-pointer group`}
              data-testid={`service-card-${index}`}
              style={{
                background: service.image ? `linear-gradient(to bottom, rgba(15, 23, 42, 0.3), rgba(15, 23, 42, 0.7)), url('${service.image}')` : '#FFFFFF',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: service.gridClass.includes('row-span-2') ? '400px' : '200px',
                border: '1px solid #E2E8F0'
              }}
            >
              <div className="p-8 h-full flex flex-col justify-end">
                <service.icon
                  className="w-12 h-12 mb-4"
                  style={{ color: service.image ? '#7DD3FC' : '#0284C7' }}
                />
                <h3
                  className="text-2xl font-medium mb-2"
                  style={{ fontFamily: 'Outfit', color: service.image ? '#FFFFFF' : '#0F172A' }}
                >
                  {service.title}
                </h3>
                <p
                  className="text-base leading-relaxed"
                  style={{ color: service.image ? 'rgba(255, 255, 255, 0.9)' : '#475569' }}
                >
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;